export class DKJordPolygon {
    public shape: string | null | undefined = undefined;
    public type: number | null | undefined = -1;
    public area: number | null | undefined = -1;
    public pollutionStatus: string | null | undefined = undefined;
    public pollutionStatusDescription: string | null | undefined = undefined;

    public constructor(init: Partial<DKJordPolygon>) {
        Object.assign(this, init);
    }
}

export class DKJordPolygonResult {
    public polygonData: DKJordPolygon[] = [];

    public constructor(init: Partial<DKJordPolygonResult>) {
        Object.assign(this, init);
    }
}
